export default "__VITE_ASSET__2eca28fb__"